import { Platform } from '@angular/cdk/platform'
import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { UnespCoreMessageService } from '@unesp/core'
import { ArquivoPDF } from 'src/app/models/arquivo-pdf'

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.css'],
  standalone: false
})
export class PdfViewerComponent implements AfterViewInit {
  @ViewChild('iframe') iframe?: ElementRef
  isMobile: boolean

  constructor(
    public dialogRef: MatDialogRef<PdfViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ArquivoPDF,
    private platform: Platform,
    private messageService: UnespCoreMessageService
  ) {
    this.isMobile = this.platform.ANDROID || this.platform.IOS || this.isMobileResolution()
  }

  isMobileResolution(): boolean {
    // Determina se a resolução da tela é compatível com dispositivos móveis
    const minWidthForMobile = 768 // Defina o valor de largura mínima para dispositivos móveis
    return window.innerWidth < minWidthForMobile
  }

  ngAfterViewInit(): void {
    if (this.isMobile) {
      this.download()
    } else {
      if (this.iframe) {
        this.iframe.nativeElement.src = this.data.url
      }
    }
  }

  download() {
    // Download
    let downloadLink = document.createElement('a')
    downloadLink.setAttribute('download', this.data.titulo.concat('.pdf'))
    downloadLink.href = this.data.url
    document.body.appendChild(downloadLink)
    downloadLink.click()
    downloadLink.remove()
    // Mensagem
    this.messageService.showMessageSuccess('O download do arquivo foi realizado com sucesso')
    // Fecha
    this.dialogRef.close()
  }
}